import { render, staticRenderFns } from "./TransferCommandQuery.vue?vue&type=template&id=b3589b26"
import script from "./TransferCommandQuery.vue?vue&type=script&lang=js"
export * from "./TransferCommandQuery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports